import moment from "moment";
import { ContractReportQueryDto, ContractStatusDto } from "../../../autogen/bff-api";

interface BuildStatusFiltersInput {
  base: Partial<ContractReportQueryDto>;
  useLimitZero?: boolean;
}

const withCommonResets = (base: Partial<ContractReportQueryDto>): Partial<ContractReportQueryDto> => ({
  ...base,
  statuses: undefined,
  startDateFrom: undefined,
  startDateTo: undefined,
  endDateFrom: undefined,
  endDateTo: undefined,
  terminationDateFrom: undefined,
  terminationDateTo: undefined,
  hasNoEndDate: undefined,
});

const maybeWithLimitZero = (
  q: Partial<ContractReportQueryDto>,
  useLimitZero?: boolean
): Partial<ContractReportQueryDto> => (useLimitZero ? { ...q, limit: 0 } : q);

const buildStatusFilters = (
  status: ContractStatusDto,
  { base, useLimitZero }: BuildStatusFiltersInput
): Partial<ContractReportQueryDto> =>
  maybeWithLimitZero({ ...withCommonResets(base), statuses: [status] }, useLimitZero);

export const buildAwardedFilters = (input: BuildStatusFiltersInput): Partial<ContractReportQueryDto> =>
  buildStatusFilters(ContractStatusDto.Awarded, input);

export const buildActiveFilters = (input: BuildStatusFiltersInput): Partial<ContractReportQueryDto> =>
  buildStatusFilters(ContractStatusDto.Active, input);

export const buildExpiredFilters = (input: BuildStatusFiltersInput): Partial<ContractReportQueryDto> =>
  buildStatusFilters(ContractStatusDto.Expired, input);

export const buildTerminatedFilters = (input: BuildStatusFiltersInput): Partial<ContractReportQueryDto> =>
  buildStatusFilters(ContractStatusDto.Terminated, input);

export const buildExpiringThisYearFilters = ({
  base,
  useLimitZero,
}: BuildStatusFiltersInput): Partial<ContractReportQueryDto> => {
  const today = moment().startOf("day");
  const q: Partial<ContractReportQueryDto> = {
    ...withCommonResets(base),
    statuses: [ContractStatusDto.Active],
    endDateFrom: today.clone().format("YYYY-MM-DD"),
    endDateTo: today.clone().endOf("year").format("YYYY-MM-DD"),
  };
  return maybeWithLimitZero(q, useLimitZero);
};
